import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'BaseDataService',
    controller: 'UniformConfig'
}
const methods = [
    'GetDataBySearch',
    'GetConfigItemsList',
    'GetConfigPagingList',
    'AddConfig',
    'DelConfig',
    'UpdateConfig'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const UniformConfigApi = ZJApi.defineNewApi('UniformConfigApi', factory)

export default UniformConfigApi